import { Form, InputNumber } from 'antd';
import { ChangeEvent, FC, } from 'react';
import { useTranslation } from 'react-i18next';

interface IProps {
  pointSections: any;
  setPointSections: any;
}

const GemstonesInput: FC<IProps> = ({ 
  pointSections, 
  setPointSections,
}) => {
  const { t } = useTranslation();

  const handleJJAMChange = (value: any) => {
    if (!value) return;

    if (pointSections.length > value) {
      setPointSections(
        pointSections.filter((item: any, index: number) => index !== value),
      );
    } else {
      setPointSections([
        ...pointSections,
        { seq: pointSections.length + 1, sectionPoint: 0 },
      ]);
    }
  };

  const hanldeGemBlur = (e: ChangeEvent<HTMLInputElement>, key: number) => {
    setPointSections(
      pointSections.map((item: any) => {
        if (item?.seq === key) {
          return {
            ...item,
            sectionPoint: isNaN(Number(e.target.value))
              ? 0
              : (Math.round(Number(e.target.value)) as number),
          };
        }
        return item;
      }),
    );
  };

  return (
    <>
      <div className='comm-bx__between'>
        <h3 className='sub-title w-200'>{t('program.point.1')}</h3>
        <InputNumber
          min={1}
          max={10}
          className="form-control"
          value={pointSections?.length}
          onChange={handleJJAMChange}
        />
      </div>
      <div className="comm-table__area">                 
        <table>
          <colgroup>
            <col style={{ width: '100%' }} />                     
          </colgroup>                    
          <tbody>
            <tr>                      
              <td>
                <div className='comm-gap'>
                  {pointSections?.map((item: any) => {
                    return (
                      <input
                        key={item?.seq}
                        type="text"
                        className="form-control"
                        style={{ width: '100px' }}
                        placeholder="Score"
                        name="sectionPoint"
                        value={item?.sectionPoint}
                        onChange={(e) => hanldeGemBlur(e, item.seq)}
                      />
                    );
                  })}
                </div>
              </td>                        
            </tr>
          </tbody>
        </table>  
      </div> 
    </>
  );
};

export default GemstonesInput;
